import React from 'react';
import Box from '@mui/material/Box';
import TrialPeriodNag from './TrialPeriodNag';
import DisplayBreadCrumb from './DisplayBreadCrumb';
import DisplaySectionTitleAndDescription from './DisplaySectionTitleAndDescription';
import CompanyNag from './CompanyNag';
import TenantDropDown from '../reports/TenantDropDown';
import { useCustomerPageContext } from '../../contexts/CustomerPageContext';

export default function CustomerPageScaffold({
    children,
    breadcrumbPaths,
    sectionTitle,
    sectionDescription = '',
    isAdminPage = false,
    company: companyOverride,
    selectedTenant: tenantOverride,
    openCompanyNag: openCompanyNagOverride,
    setOpenCompanyNag: setOpenCompanyNagOverride,
    showTrialPeriodNag = true,
    showCompanyNag = true,
    showTenant = true,
    headerAdornment = null,
}) {
    const context = useCustomerPageContext();
    const company = companyOverride || context.company;
    const selectedTenant = tenantOverride || context.selectedTenant;
    const openCompanyNag = openCompanyNagOverride ?? context.openCompanyNag;
    const setOpenCompanyNag = setOpenCompanyNagOverride || context.setOpenCompanyNag;

    return (
        <>
            {showTrialPeriodNag && company && <TrialPeriodNag company={company} />}
            <DisplayBreadCrumb paths={breadcrumbPaths || []} />
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: isAdminPage ? 0 : 2.5 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <DisplaySectionTitleAndDescription
                        sectionTitle={sectionTitle}
                        sectionDescription={sectionDescription}
                        isAdminPage={isAdminPage}
                    />
                </Box>
                {headerAdornment && (
                    <Box
                        sx={{
                            flexShrink: 0,
                            p: 1.25,
                            borderRadius: 2,
                            bgcolor: 'primary.light',
                            lineHeight: 0,
                        }}
                    >
                        {headerAdornment}
                    </Box>
                )}
            </Box>
            {showCompanyNag && company && (
                <CompanyNag
                    company={company}
                    openCompanyNag={openCompanyNag ?? true}
                    setOpenCompanyNag={setOpenCompanyNag || (() => {})}
                />
            )}
            {showTenant && selectedTenant && (
                <TenantDropDown company={company || { tenantList: [selectedTenant] }} selectedTenantOption={selectedTenant} />
            )}
            {children}
        </>
    );
}
